import {getColoredUseLine} from '../../helpers/rollout-message-text-helpers.js'

export default {
  name: "[Name Needed]",
  description: "[Description Needed]",
  //animation: "tada", //Hmm. Will PROBABLY keep this, but not totally sure.

  category: "none", //for iconography

  //Cost
  ppCost: 0,

  //Danger Meter
  increaseDangerMeterOnUse: 15,
  affectTargetDangerMeter: 0,

  //HP
  affectTargetHpPoints: 0,
  affectTargetHpPointsByPercent: 0,
  affectCasterHpPoints: 0,
  affectCasterHpPointsByPercent: 0,

  hasTimedHitBonusAvailable: false,
  //TimedHitBonus
  //TODO:
  // This feature was removed during b5 testing because it felt like a tacked on mini game.
  //HOWEVER, we can still use this flag as a potential damage bonus when adding Character Upgrades.
  //For example, any action that has `hasTimedHitBonusAvailable:true` may have a chance of tacking on extra damage
  //Based on a % of character stats/upgrades. You should probably rename it to something like "isBonusDamageEligible"
  
  //PP Increase
  affectTargetPpPoints: 0,

  //ForEach and other loops
  affectTargetHpPointsInRepetitions: null, //{min:1, max: 4, affectTargetHpPoints: -4}

  affectTargetAttackModifier: 0,
  affectTargetDefenseModifier: 0,
  affectTargetSpecialModifier: 0,
  affectTargetSpeedModifier: 0,
  affectTargetAccuracyModifier: 0,

  affectCasterAttackModifier: 0,
  affectCasterDefenseModifier: 0,
  // affectCasterSpecialModifier: 0,
  affectCasterSpeedModifier: 0,


  bypassCasterAttackStats: false, //Don't let move use the Attack stat, like "Insult" //TODO: not used yet, but should be used for Promise (first hit)

  //Many targets, but randomly select one at runtime (EX: Promise resolve)
  selectRandomTargetForSingleHit: false,

  //Status multiplier
  statusMultiplier: null, //[status, rate] EX: ["deadline", 1.5]



  //Item stats
  itemValue: 0, //This could be used to determine "worth", like which items are worth more. Maybe it's market cost? IDK
                //TODO: at any rate, it's not being used yet.

  //statuses
  affectTargetStatus: null, //"normal", "memory-leak", "lag", "fury", "zen", "fire// array?
  affectCasterStatus: null, //"normal", "memory-leak", "lag", "fury", "zen", "fire
  //["from","to"]["mustBeThisStatus", "toBecomeThisStatus"]... or "["*", "canChangeToThisFromAnyStatus"]

  statusTurnCount: [], /* [min, max] */


  isImmuneFromLag: false, //This move never gets "lost in lag".

  //Theft
  theftQuantity: 0,
  //theftQuality: "random", /* best, worst */
  //targetResistanceNeeded: 0, /* target needs defense roll higher than this (?), or it will fail */
  stealAndUseItem: false,

  //Sabotage Item (EX: Bug)
  sabotageItemQuantity: 0,

  //Delete Item (EX: SQL Injection)
  deleteItemQuantity: 0,

  //Turn status
  speedModifier: 0, //TODO: analyze useages of this (at the ACTION level). This isn't really relevant anymore, right?

  //Accuracy
  accuracyModifier: 0, /* 1 = 1%... -15 = 15% chance it will miss. (not factoring Combatant's accuracyModifier too) */
  canMiss: true, //Automatic option for shutting off potential misses.

  //Time Travel
  changeCasterCommittedData: false,
  useCasterCommittedData: false,
  clearTargetCommittedData: false,

  //Targeting
  targetType: "single-opponent", //"single-opponent", "opponent-team", "single-ally", "ally-team", "only-me"
  targetMustBeDead: false,
  targetCanBeDead: false, //This works on either dead or alive people

  ignoreCasterDieResult: false, //Bypass annoucement that caster is dead (like, if a Promise resolves but the original caster is already dead)
  ignoreTargetDieResult: false, //Bypass annoucement that target is dead
    // (like, if an Item stealing or deleting thing is used on the whole team, but this person dead)
    //


  getValidity(actionModel, casterModel, targetModels) { //Return whether this will be an auto fail
    /*
     EX:
     if (targetCombatantModel.status !== "lag") {
     return {
     isValid: false,
     invalidReasons: ["Target is not lagging!"]
     }
     */
    return {
      isValid: true,
      invalidReasons: []
    };
  },

  //Type
  isItem: false,
  isSuper: false,
  // isSpecialAttack: false,

  //Canceling
  canBeReplaced: true, //If this needs to be more advanced ever, consider replacing this with a function that evaluates to true or false

  //Rollout Messages
  shouldFail: function (actionModel, casterModel, targetModels) {
    return false; //Return boolean
  },
  getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
    return [
      getColoredUseLine(casterModel.id, actionModel.name, "")
    ]
  },
  getFailStep: function (actionModel, casterModel, targetModels, descriptionObject) {
    return [
      getColoredUseLine(casterModel.id, actionModel.name, ""),
      {
        type: "message",
        content: [
          `...but it failed!`,
        ]
      }
    ]
  },
  getMissStep: function (actionModel, casterModel, targetModels, descriptionObject) {
    return [
      getColoredUseLine(casterModel.id, actionModel.name, ""),
      {
        type: "message",
        content: [
          `but it missed!`,
        ]
      }
    ]
  },

  getFollowupActions: function (actionModel, casterModel, targetModels, descriptionObject) {
    return [
      // {
      //     action: {
      //         id: "the-action-id",
      //         casterId: casterModel.id,
      //         targetIds: [casterModel.id] //just the IDs of targets
      //              Or something like targetIds: targetModels.map(targetModel => targetModel.id)
      //     },
      //     turnRange: [2, 5]
      // }
    ]
  },
  getBuggedStep() {
    return []
  },


  //Meta
  actionMeta: {
    //libraryId, isStolen, timed bonus, etc.
    //Other flags that describe this exact instance of the submitted action
  }


}


// WEBPACK FOOTER //
// ./src/battle/models/ActionModel.js